module.exports = __webpack_public_path__ + "static/cpw-9cc2b6491f05678e288281803e9ba0ba.png";